import { render, staticRenderFns } from "./FormControlThemesCssGroups.vue?vue&type=template&id=30064cfc"
import script from "./FormControlThemesCssGroups.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlThemesCssGroups.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports